export const theme = {
  colors: {
    background: '#050505',
    text: '#ffffff',
    textMuted: '#a1a1aa',
    primary: '#E7A55F', // Gold/Orange
    secondary: '#9DCCC3', // Pale Teal
    accent: '#ED823F', // Dark Orange
    surface: 'rgba(255, 255, 255, 0.03)',
    surfaceHover: 'rgba(255, 255, 255, 0.08)',
    border: 'rgba(255, 255, 255, 0.1)',
    white: '#FFFFFF',
    black: '#000000',
    success: '#48BB78',
    warning: '#F6E05E',
    danger: '#F56565',
  },
  gradients: {
    primary: 'linear-gradient(135deg, #E7A55F, #ED823F)',
    secondary: 'linear-gradient(135deg, #9DCCC3, #7AB8AE)',
  },
  fonts: {
    light: '300',
    regular: '400',
    medium: '500',
    semiBold: '600',
    bold: '700',
  }
};
